import cntl from "cntl";
import { Badge } from ".";
import PropTypes from "prop-types";
import { SIZE } from "../constants";
import { useMemo, useState } from "react";
import { getBadgeColors } from "@dbox/core/utils/getBadgeColors";
import { IconX } from "@tabler/icons-react";

const propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  isOutline: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md, SIZE.lg]),
};

function BadgeTag({ label, size, className, isOutline, onClick }) {
  const [padding, setPadding] = useState("");

  const badgeColors = useMemo(() => getBadgeColors(label), [label]);

  const colorsFilled = () => cntl`
    ${badgeColors?.backgroundColor}
  `;

  const colorsOutline = () => cntl`
    outline
    bg-white
    outline-[1.5px]
    outline-offset-[-1.5px]
    ${badgeColors?.bordersColor}
  `;

  const colors = () => cntl`
    ${badgeColors?.textColor}
    ${isOutline ? colorsOutline() : colorsFilled()}
  `;

  const badgeTagCn = () => cntl`
    gap-x-1
    rounded-2xl
    ${padding}
    ${colors()}
    ${className ? className : undefined}
  `;

  const iconCn = () => cntl`
    w-3
    h-3
    order-1
    ${badgeColors?.iconColor}
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.sm:
        setPadding("pl-2 pr-1.5");
        break;
      case SIZE.md:
        setPadding("pl-2.5 pr-1.5");
        break;
      case SIZE.lg:
        setPadding("pl-3 pr-2.5");
        break;
      default:
        setPadding("pl-2 pr-1.5");
        break;
    }
  }, [size]);

  return (
    <Badge className={badgeTagCn()} label={label} size={size}>
      <IconX className={iconCn()} onClick={() => onClick(label)} />
    </Badge>
  );
}

BadgeTag.propTypes = propTypes;
export default BadgeTag;
